<form [formGroup]="form">
  <fieldset>
    <div class="column">
      <!-- Responsable field -->
      @if (showDestinataireResponsableField) {
        <div class="col-6 mb-3">
          <!-- <div class="row"> -->
          <label class="label col-12 col-form-label" for="destinataireResponsable">Chefs de service *</label>
          <div class="form-text mb-1">Sélectionnez destinataire (service: Chef de service).</div>
          <mat-form-field class="w-100">
            <mat-select formControlName="destinataireResponsable" [compareWith]="compareId">
              @for (responsable of responsableList; track responsable) {
                <mat-option [value]="responsable">
                  {{ responsable.nom }} {{ responsable.prenom }}
                </mat-option>
              }
            </mat-select>
            @if (form.get('destinataireResponsable')?.invalid && form.get('destinataireResponsable')?.touched) {
              <mat-error>
                Ce champ est obligatoire.
              </mat-error>
            }
          </mat-form-field>
        <!-- </div> -->
      </div>
    }

    <!-- Directeur field -->
    @if (showDestinataireDirecteurField) {
      <div class="col-6 mb-3">
        <!-- <div class="row"> -->
        <label class="label col-12 col-form-label" for="destinataireValidation">Directeurs *</label>
        <div class="form-text mb-1">Sélectionnez destinataire (service: Directeurs service).</div>
        <mat-form-field class="w-100">
          <mat-select formControlName="destinataireValidation" [compareWith]="compareId">
            @for (directeur of directeursList; track directeur) {
              <mat-option [value]="directeur">
                {{ directeur.nom }} {{ directeur.prenom }}
              </mat-option>
            }
          </mat-select>
          @if (form.get('destinataireValidation')?.invalid && form.get('destinataireValidation')?.touched) {
            <mat-error>
              Ce champ est obligatoire.
            </mat-error>
          }
        </mat-form-field>
      <!-- </div> -->
    </div>
  }

  <!-- GPEEC field -->
  @if (showDestinataireGpeecField) {
    <div class="col-6 mb-3">
      <!-- <div class="row"> -->
      <label class="label col-12 col-form-label" for="destinataireChargeGpec">{{ libelleGpeecListe }} *</label>
      <div class="form-text mb-1">Sélectionnez {{ libelleGpeecListe }}.</div>
      <mat-form-field class="w-100">
        <mat-select formControlName="destinataireChargeGpec" [compareWith]="compareId">
          @for (gpeec of gpeecList; track gpeec) {
            <mat-option [value]="gpeec"> {{ gpeec.nom }} {{ gpeec.prenom }} </mat-option>
          }
        </mat-select>
        @if (form.get('destinataireChargeGpec')?.invalid && form.get('destinataireChargeGpec')?.touched) {
          <mat-error>
            Ce champ est obligatoire.
          </mat-error>
        }
      </mat-form-field>
    <!-- </div> -->
  </div>
}

<!-- DRH field -->
@if (showDestinataireDrhField) {
  <div class="col-6 mb-3">
    <!-- <div class="row"> -->
    <label class="label col-12 col-form-label" for="destinataireDrh">DRH *</label>
    <div class="form-text mb-1">Sélectionnez destinataire (service: DRH).</div>
    <mat-form-field class="w-100">
      <mat-select formControlName="destinataireDrh" [compareWith]="compareId">
        @for (drh of drhList; track drh) {
          <mat-option [value]="drh"> {{ drh.nom }} {{ drh.prenom }} </mat-option>
        }
      </mat-select>
      @if (form.get('destinataireDrh')?.invalid && form.get('destinataireDrh')?.touched) {
        <mat-error>
          Ce champ est obligatoire.
        </mat-error>
      }
    </mat-form-field>
  <!-- </div> -->
</div>
}

<!-- DG field -->
@if (showDestinataireDgField) {
  <div class="col-6 mb-3">
    <!-- <div class="row"> -->
    <label class="label col-12 col-form-label" for="destinataireDg">DG du pôle *</label>
    <div class="form-text mb-1">Sélectionnez destinataire DG (service: DG Administrative).</div>
    <mat-form-field class="w-100">
      <mat-select formControlName="destinataireDg" [compareWith]="compareId">
        @for (dg of dgList; track dg) {
          <mat-option [value]="dg"> {{ dg.nom }} {{ dg.prenom }} </mat-option>
        }
      </mat-select>
      @if (form.get('destinataireDg')?.invalid && form.get('destinataireDg')?.touched) {
        <mat-error>
          Ce champ est obligatoire .
        </mat-error>
      }
    </mat-form-field>
  <!-- </div> -->
</div>
}

<!-- DGS field -->
@if (showDestinataireDgsField) {
  <div class="col-6 mb-3">
    <!-- <div class="row"> -->
    <label class="label col-12 col-form-label" for="destinataireDgs">DGS *</label>
    <div class="form-text mb-1">Sélectionnez destinataire DGS.</div>
    <mat-form-field class="w-100">
      <mat-select formControlName="destinataireDgs" [compareWith]="compareId">
        @for (dgs of dgsList; track dgs) {
          <mat-option [value]="dgs"> {{ dgs.nom }} {{ dgs.prenom }} </mat-option>
        }
      </mat-select>
      @if (form.get('destinataireDgs')?.invalid && form.get('destinataireDgs')?.touched) {
        <mat-error>
          Ce champ est obligatoire.
        </mat-error>
      }
    </mat-form-field>
  <!-- </div> -->
</div>
}

<!-- Archivage RH field -->
@if (showDestinataireArchivageRhField) {
  <div class="col-6 mb-3">
    <!-- <div class="row"> -->
    <label class="label col-12 col-form-label" for="destinataireArchivageRh">Archivage RH *</label>
    <div class="form-text mb-1">Sélectionnez destinataire Archivage RH.</div>
    <mat-form-field class="w-100">
      <mat-select formControlName="destinataireArchivageRh" [compareWith]="compareId">
        @for (archivageRh of archivageRhList; track archivageRh) {
          <mat-option [value]="archivageRh">
            {{ archivageRh.nom }} {{ archivageRh.prenom }}
          </mat-option>
        }
      </mat-select>
      @if (form.get('destinataireArchivageRh')?.invalid && form.get('destinataireArchivageRh')?.touched) {
        <mat-error>
          Ce champ est obligatoire.
        </mat-error>
      }
    </mat-form-field>
  <!-- </div> -->
</div>
}
</div>
</fieldset>
</form>
